// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"97b74c86","64":"23a0b696","76":"88c4dd56","144":"fbbbbc0b","376":"ba78667d","404":"d5c52d3a","724":"2e29d4f4","808":"45414e05","840":"940336f0","892":"d0096c8e","904":"3117b041","952":"ef9ade5c"}[chunkId] + ".chunk.js";
};